import { render, staticRenderFns } from "./LookupAdmin.vue?vue&type=template&id=13ee3881&scoped=true"
import script from "./LookupAdmin.vue?vue&type=script&lang=js"
export * from "./LookupAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ee3881",
  null
  
)

export default component.exports